import React from "react";
import useFormPrefix from "./useFormPrefix";
import ReadonlyContext from "../contexts/ReadonlyContext";
/**
 * Hook to get the readonly context
 * @param prefixArg - The prefix of the field to check if it's readonly. By default will used current form prefix
 * @param overwrittenDisabled - If you want to overwrite the disabled state, mostly used in the fields
 * @returns {{isReadonly: boolean, isDisabled, message: *}}
 */
const useReadonlyContext = (prefixArg = null, overwrittenDisabled = null) => {
	const { readonlyConfig } = React.useContext(ReadonlyContext) || {};
	const prefixContext = useFormPrefix();
	const prefix = prefixArg === null ? prefixContext : prefixArg;

	return React.useMemo(() => {
		const res = readonlyConfig?.(prefix);

		const isReadonly = !!res;

		return {
			message: res?.message,
			isReadonly,
			isDisabled: overwrittenDisabled || isReadonly
		};
	}, [readonlyConfig, prefix, overwrittenDisabled]);
};

export default useReadonlyContext;
